import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ApiTokenSummary, CreateApiTokenResponse } from './api/engineApiTokensEngineSlice';

export type EngineApiTokensModalState =
    | { kind: 'closed' }
    | { kind: 'create' }
    | { kind: 'reveal'; payload: CreateApiTokenResponse }
    | { kind: 'detail'; token: ApiTokenSummary }
    | { kind: 'revoke'; token: ApiTokenSummary };

export type EngineApiTokensState = {
    modal: EngineApiTokensModalState;
};

const initialState: EngineApiTokensState = {
    modal: { kind: 'closed' },
};

const engineApiTokensSlice = createSlice({
    name: 'engineApiTokens',
    initialState,
    reducers: {
        openCreate: state => {
            state.modal = { kind: 'create' };
        },
        openReveal: (state, action: PayloadAction<CreateApiTokenResponse>) => {
            state.modal = { kind: 'reveal', payload: action.payload };
        },
        openDetail: (state, action: PayloadAction<ApiTokenSummary>) => {
            state.modal = { kind: 'detail', token: action.payload };
        },
        openRevoke: (state, action: PayloadAction<ApiTokenSummary>) => {
            state.modal = { kind: 'revoke', token: action.payload };
        },
        closeModal: state => {
            state.modal = { kind: 'closed' };
        },
    },
});

export const { openCreate, openReveal, openDetail, openRevoke, closeModal } = engineApiTokensSlice.actions;

export default engineApiTokensSlice.reducer;
